import React, { createContext, useContext, useState } from "react";
import { Backdrop, CircularProgress, Typography } from "@mui/material";

export interface LoaderContextProps {
    isLoading: boolean;
    showLoader: () => void;
    hideLoader: () => void;
}

export const LoaderContext = createContext<LoaderContextProps | undefined>(undefined);

export const LoaderContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [isLoading, setIsLoading] = useState(false);

    const showLoader = () => setIsLoading(true);
    const hideLoader = () => setIsLoading(false);

    return (
        <LoaderContext.Provider value={{ isLoading, showLoader, hideLoader }}>
            {children}
            <Backdrop
                open={isLoading}
                sx={{
                    zIndex: (theme) => theme.zIndex.modal + 1,
                    color: "#fff",
                    flexDirection: "column",
                }}
            >
                <CircularProgress color="primary" />
                <Typography variant="body1" sx={{ mt: 2 }}>
                    Cargando, por favor espere...
                </Typography>
            </Backdrop>
        </LoaderContext.Provider>
    );
};


